import { TFunction } from 'react-i18next';
import { ObjectValues } from 'common/tsHelpers.ts';
import { z } from 'zod';

export const PROVISIONING_SOURCE = {
  FILE_UPLOAD: 0,
  ORDER: 1,
  MANUAL_ACTION: 2,
} as const;

export const provisioningSourceFilterSchema = z.array(
  z.union([
    z.literal(PROVISIONING_SOURCE.FILE_UPLOAD),
    z.literal(PROVISIONING_SOURCE.ORDER),
    z.literal(PROVISIONING_SOURCE.MANUAL_ACTION),
  ]),
);
export type ProvisioningSourceFilter = z.infer<typeof provisioningSourceFilterSchema>;

export type ProvisioningSource = ObjectValues<typeof PROVISIONING_SOURCE>;

export const parseSourcesFilter = (source: string[] | null): ProvisioningSourceFilter => {
  if (!source) {
    return [];
  }

  const sourceParams = source.map((source) => Number.parseInt(source));

  try {
    const parcedSource = provisioningSourceFilterSchema.parse(sourceParams);
    return parcedSource;
  } catch {
    return [];
  }
};

export const mapSourceValueToLabel = (
  source: ProvisioningSource,
  t: TFunction<'translation', undefined>,
) => {
  switch (source) {
    case PROVISIONING_SOURCE.FILE_UPLOAD:
      return t('bulkProvisioning.fileUpload');
    case PROVISIONING_SOURCE.MANUAL_ACTION:
      return t('bulkProvisioning.manualAction');
    case PROVISIONING_SOURCE.ORDER:
      return t('bulkProvisioning.order');
  }
};
